var map = {
	"./1.gif": 16,
	"./10.gif": 17,
	"./11.gif": 18,
	"./12.gif": 19,
	"./13.gif": 20,
	"./14.gif": 21,
	"./15.gif": 22,
	"./2.gif": 23,
	"./3.gif": 24,
	"./4.gif": 25,
	"./5.gif": 26,
	"./6.gif": 27,
	"./7.gif": 28,
	"./8.gif": 29,
	"./9.gif": 30
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;